var App = App || {};

App.Base = (function ($) {
    'use strict';

    let bsElements = {};

    let modals = [];
    let modalFlag = false;

    const speedBump = $("#SpeedBump");
    let speedBumpExempt = typeof SpeedbumpData !== 'undefined' ? [...SpeedbumpData.ExemptList] : [];

    function BsElements() {

        bsElements = {
            accElements: [...$("[data-bs-toggle='collapse']")].filter(x => x.getAttribute("id") != "").map(x => `#${x.getAttribute("id")}`),
            tabElements: [...$("[data-bs-toggle='tab']")].filter(x => x.getAttribute("id") != "").map(x => `#${x.getAttribute("id")}`),
            offcanvasElements: [...$(".offcanvas")].filter(x => x.getAttribute("id") != "").map(x => `#${x.getAttribute("id")}`)
        };

        const hash = location.hash;
        if (hash) BsElementsExecute(hash);
    }

    function ChatWindowExecute(e, href, jsTrigger) {
        if (href?.toLowerCase() == "#aiq_chat_app" || jsTrigger?.toLowerCase() == "chat") {
            e.preventDefault();
            window.__aiq.openChatWindow();
            return true;
        }
    }

    function KetchExecute(e, jsTrigger) {
        if (jsTrigger?.toLowerCase() == "ketch") {
            e.preventDefault();
            ketch('showExperience');
            return true;
        }
    }

    function BsElementsExecute(candidate) {

        const pathName = window.location.pathname;
        if (candidate?.startsWith(pathName)) candidate = candidate.slice(pathName.length);

        let bsType = false;

        for (const key in bsElements) {
            if (bsElements[key].includes(candidate)) {
                bsType = key;
            }
        }

        if (bsType == false)
            return false;

        if (bsType == "accElements") {
            const button = $(candidate);
            const collapse = button.parents(".accordion-item").find(".accordion-collapse");
            button.trigger("focus");
            $("html, body").animate({ scrollTop: button.offset().top }, 200);
            collapse.collapse("show");
        }
        else if (bsType == "tabElements") {
            const tab = $(candidate);
            tab.tab("show").trigger("focus");
            $("html, body").animate({ scrollTop: tab.offset().top }, 200);
        }
        else if (bsType == "offcanvasElements") {
            const offcanvas = $(candidate);
            offcanvas.offcanvas("show");
        }

        return true;
    }

    function Modals() {

        $.ajax({
            type: "GET",
            url: "/Api/Modals/GetModalUrls",
            success: function (result) {
                modals = [...result];
                const href = location.hash.replace("#", "/").toLowerCase();
                ModalsExecute(href, null);
            }
        })
    }

    function ModalsExecute(href, clicked) {

        if (href === "" || !modals.some(m => m.toLowerCase() === href.toLowerCase()))
            return false;

        $.ajax({
            type: "GET",
            url: href,
            success: function (result) {

                const modalData = {
                    "id": $(result).filter(".modal, .offcanvas").attr("id"),
                    "content": $(result).filter(".modal, .offcanvas").prop("outerHTML")
                };

                $("body").append(modalData.content);
                const modal = $(`#${modalData.id}`);
                App.Base.ClickSupport(modal.find("a"));

                let showMethod = null;
                let hiddenEvent = null;

                if (modal.hasClass("modal")) {
                    showMethod = "modal";
                    hiddenEvent = "hidden.bs.modal";
                }
                else if (modal.hasClass("offcanvas")) {
                    showMethod = "offcanvas";
                    hiddenEvent = "hidden.bs.offcanvas";
                }

                $("#OffcanvasMenu").offcanvas("hide");

                modal[showMethod]("show").on(hiddenEvent, function () {
                    if (clicked !== null) {
                        clicked.trigger("focus").trigger("blur");
                    }
                    if (!modalFlag) {
                        $(this).remove();
                    }
                });

            }
        });

        return true;
    }

    function SpeedBumpExecute(clicked) {

        const hostname = clicked[0].hostname;
        const href = clicked.attr("href");

        if (hostname === location.hostname || $.inArray(hostname, speedBumpExempt) !== -1 || !href || IsUriSchema(href)) {
            return false;
        }

        // check to see if speedbump was triggered from a modal
        const modalParent = clicked.parents(".modal").first();
        modalFlag = modalParent.length != 0;
        modalParent.modal("hide");

        speedBump.modal("show");
        speedBump.find("button[data-speedbump='proceed']")
            .off("click")
            .on("click", function () {
                speedBump.modal("hide");
                window.open(href);
            }
        );

        speedBump.on("hidden.bs.modal", function () {
            clicked.trigger("focus").trigger("blur");
            if (modalFlag) {
                modalParent.modal("show");
                modalFlag = false;
            }
        });

        return true;

    }

    function ModalAnchorLinkExecute(clicked) {

        const parentModal = clicked.parents(".modal, .offcanvas").first();
        const href = clicked.attr("href") || "";
        const hash = href.includes("#") ? "#" + href.split("#")[1] : null;
        const hrefPart = href.split("#")[0];
        const isThisPage = hrefPart === "" || hrefPart === location.pathname;

        if (parentModal.length && isThisPage && hash) {

            event.preventDefault();

            parentModal.one("hidden.bs.modal hidden.bs.offcanvas", function () {
                const target = $(hash);
                if (target.length) {
                    $("html, body").animate({
                        scrollTop: target.offset().top
                    }, 300);
                }
            });

            if (parentModal.hasClass("offcanvas")) parentModal.offcanvas("hide");
            else if (parentModal.hasClass("modal")) parentModal.modal("hide");
        }
    }

    function ClickSupport(selector) {

        selector.on("click", function (e) {

            const href = $(this).attr("href");
            const jsTrigger = $(this).data("js-trigger");

            if (ChatWindowExecute(e, href, jsTrigger) == true)
                return false;

            if (KetchExecute(e, jsTrigger) == true)
                return false;

            if (BsElementsExecute(href) == true)
                return false;

            if (ModalsExecute(href, $(this)) == true) {
                e.preventDefault();
                return false;
            }

            if (SpeedBumpExecute($(this)) == true) {
                e.preventDefault();
                return false;
            }

            if (ModalAnchorLinkExecute($(this)) == true) {
                return false;
            }
        });
    }

    function IsUriSchema(href) {

        const uriSchemes = ["javascript:", "mailto:", "tel:"];

        for (var i in uriSchemes) {
            if (href.indexOf(uriSchemes[i]) > -1) {
                return true;
            }
        }
        return false;
    }

    function RichTextResponsiveTables(selector) {
        selector.each(function () {
            if (!$(this).parent().hasClass("table-responsive")) {
                $(this).wrap("<div class=\"table-responsive\"></div>")
            }
        });
    }

    // https://davidwalsh.name/query-string-javascript
    function GetUrlParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    };

    function AccordionJump() {
        document.querySelectorAll('.accordion').forEach(accordion => {

            let hadOpenBefore = false;

            // Track if something was already open BEFORE opening
            accordion.addEventListener('show.bs.collapse', () => {
                const openItems = accordion.querySelectorAll('.accordion-collapse.show');
                hadOpenBefore = openItems.length > 0;
            });

            accordion.addEventListener('shown.bs.collapse', (event) => {
                if (!hadOpenBefore) return;

                const panel = event.target;
                const trigger = accordion.querySelector(`[aria-controls="${panel.id}"]`);
                if (!trigger) return;

                // Wait for layout/paint to fully settle
                requestAnimationFrame(() => {
                    requestAnimationFrame(() => {

                        const rect = trigger.getBoundingClientRect();
                        const isVisible =
                            rect.top >= 0 &&
                            rect.bottom <= window.innerHeight;

                        if (isVisible) return;

                        const html = document.documentElement;
                        const prev = html.style.scrollBehavior;

                        try {
                            html.style.scrollBehavior = 'auto';
                            const y = rect.top + window.pageYOffset - 10;
                            window.scrollTo(0, y);
                        } finally {
                            html.style.scrollBehavior = prev;
                        }

                    });
                });
            });

        });
    }


    return {
        BsElements: BsElements,
        Modals: Modals,
        ClickSupport: ClickSupport,
        RichTextResponsiveTables: RichTextResponsiveTables,
        GetUrlParameter: GetUrlParameter,
        AccordionJump: AccordionJump
    };

})(jQuery);

$(function () {
    App.Base.BsElements();
    App.Base.Modals();
    App.Base.ClickSupport($("a"));
    App.Base.RichTextResponsiveTables($(".rich-text table.table"));
    App.Base.AccordionJump();
});